import { useQuery } from '@tanstack/react-query';
import {
  type StudentSessionAttendanceFilter,
  type UseQueryReturnType,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { attendanceKeys } from './keys';

const studentSessionAttendance = graphql(/* GraphQL */ `
  query studentSessionAttendance($filter: StudentSessionAttendanceFilter) {
    attendance_studentSessionAttendance(filter: $filter) {
      dateAttendance {
        date
        bellTimeAttendance {
          bellTimeId
          bellTime {
            time
            name
          }
          attendanceCode {
            id
            name
            description
            code
            codeType
          }
          note
          createdBy {
            partyId
            firstName
            lastName
            type
            avatarUrl
            title {
              id
              name
              nameTextId
            }
          }
          createdByPartyId
          updatedBy {
            partyId
            firstName
            lastName
            type
            avatarUrl
            title {
              id
              name
              nameTextId
            }
          }
          updatedByPartyId
        }
      }
      studentPartyId
      student {
        person {
          partyId
          firstName
          lastName
          type
          avatarUrl
          title {
            id
            name
            nameTextId
          }
        }
      }
      classGroup {
        name
        staff {
          partyId
          firstName
          lastName
          type
          avatarUrl
          title {
            id
            name
            nameTextId
          }
        }
      }
    }
  }
`);

const attendanceQuery = (filter: StudentSessionAttendanceFilter) => ({
  queryKey: attendanceKeys.individualStudentSessionAttendance(filter),
  queryFn: async () =>
    gqlClient.request(studentSessionAttendance, {
      filter,
    }),
});

export function getAttendanceQuery(filter: StudentSessionAttendanceFilter) {
  return queryClient.fetchQuery(attendanceQuery(filter));
}

export function useStudentSessionAttendance(
  filter: StudentSessionAttendanceFilter,
) {
  return useQuery({
    ...attendanceQuery(filter),
    select: ({ attendance_studentSessionAttendance }) =>
      attendance_studentSessionAttendance[0]?.dateAttendance[0]
        ?.bellTimeAttendance,
  });
}

export type ReturnTypeFromUseStudentSessionAttendance = UseQueryReturnType<
  typeof useStudentSessionAttendance
>;
